(function ($) {

    $(".full-width-slider__slider").each(function () {
        var $fullWidthSlider = $(this);
        var $fullWidthprogressBar = $fullWidthSlider.parent().find('.full-width-slider__slider-progress');
        var $fullWidthprogressBarLabel = $fullWidthSlider.parent().find('.full-width-slider__slider-progress-label');

        $fullWidthSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

            $fullWidthprogressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $fullWidthprogressBarLabel.text(calc + '% completed');
        });

        $fullWidthSlider.slick({
            fade: false,
            dots: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $fullWidthSlider.parent().find('.button--prev'),
            nextArrow: $fullWidthSlider.parent().find('.button--next')
        });
    });

})(jQuery);
